import React from 'react'
import DragDropFileUpload from '../../../CommonComponents/DragDropFileUpload'
import ThreeStateToggleButton from '../../../CommonComponents/ThreeStateToggleButton'
import { Panel } from 'rsuite';

const AchAcceptance = ({ masterDetails, isMergeMaster }) => {
    const PanelHeader = (headerText) => {
        return (
            <h4 className={`mb-0 ${isMergeMaster ? 'd-none' : 'p-0'}`}> {headerText} </h4>
        )
    }
    return (
        <Panel header={PanelHeader("ACH Acceptance Information")} collapsible bordered>
            <div className="card supply-ach-acceptance pt-0 mt-0 border-0">
                <div className="card-content p-0">
                    <div className="item">
                        <h4 className='fw-bold text-black toggle-item-text mb-0'>Do they accept ACH Payments?</h4>
                        <ThreeStateToggleButton isDisabled={true} checked={masterDetails?.payment?.isAcceptAchPayments} />
                    </div>
                    {
                        masterDetails?.payment?.isAcceptAchPayments && (
                            <>
                                <div className="item flex-wrap flex-sm-nowrap">
                                    <h4 className='item-name flex-grow-1 flex-sm-grow-0 mb-0'>Is ACH Paid Through Portal?</h4>
                                    <ThreeStateToggleButton isDisabled={true} checked={masterDetails?.payment?.isAchThroughPortal || null} />
                                </div>
                                {
                                    masterDetails?.payment?.isAchThroughPortal && (
                                        <div className="item flex-wrap flex-sm-nowrap">
                                            <h4 className='item-name flex-grow-1 flex-sm-grow-0 mb-0'>ACH Portal URL:</h4>
                                            <input
                                                type="text"
                                                className="search-input"
                                                value={masterDetails?.payment?.achPortalURL || ''}
                                                disabled={true}
                                            />
                                        </div>
                                    )
                                }
                                {masterDetails?.payment?.isAchThroughPortal === false && (
                                    <>

                                        <div className="item flex-wrap flex-sm-nowrap">
                                            <h4 className='item-name flex-grow-1 flex-sm-grow-0 mb-0'>Bank Name:</h4>
                                            <input
                                                type="text"
                                                className="search-input"
                                                value={masterDetails?.payment?.bankName || ''}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="item flex-wrap flex-sm-nowrap">
                                            <h4 className='item-name flex-grow-1 flex-sm-grow-0 mb-0'>Bank Account Number:</h4>
                                            <input
                                                type="text"
                                                className="search-input"
                                                value={masterDetails?.payment?.bankAccountNumber || ''}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="item flex-wrap flex-sm-nowrap">
                                            <h4 className='item-name flex-grow-1 flex-sm-grow-0 mb-0'>Bank Routing Number:</h4>
                                            <input
                                                type="text"
                                                className={`search-input`}
                                                value={masterDetails?.payment?.bankRoutingNumber || ''}
                                                disabled={true}
                                            />
                                        </div>
                                    </>
                                )}
                                <div className="item flex-column ach-instructions">
                                    <h4 className='item-name flex-grow-1 flex-sm-grow-0 mb-0'>ACH Instructions:</h4>
                                    <DragDropFileUpload
                                        currentFileName={masterDetails?.payment?.achInstructions || null}
                                        isDisabled={true}
                                        customClassName='upload-vendor-file'
                                        accept='*.*'
                                        isDownload={false}
                                    />
                                </div>
                                <div className="item phone-input-parent flex-column flex-sm-row align-items-start align-items-sm-start">
                                    <h4 className='item-name flex-grow-1 flex-sm-grow-0 mb-0'>Email Address for payment notification:</h4>
                                    <div className='d-flex flex-grow-1 align-items-center gap-2 w-100'>
                                        <input
                                            type="text"
                                            className={`search-input ${masterDetails?.payment?.emailAch && masterDetails?.payment?.emailAch !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(masterDetails?.payment?.emailAch) && 'error-border'}`}
                                            value={masterDetails?.payment?.emailAch || ''}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                            </>
                        )
                    }
                </div>
            </div>
        </Panel>
    )
}

export default AchAcceptance